import React, { useState, useEffect } from "react";
import { addDestination } from "../../apis/firebase";
import { DestinationType, MAILCHIMP_CLIENT_ID } from "../../constants";
import { addUserDestination } from "../../state/User";
import { getParameter, verifyRealUser } from "../helpers";
import LoaderIcon from "../utils/icons/LoaderIcon";
import { closePopUp, showAlertPopUp, showLoadingPopUp } from "../utils/Overlay";

export function AddMailchimpDestination({
  onError,
  user,
}: {
  onError: Function;
  user: User;
}) {
  const [inProgress, setProgressFlag] = useState(false);
  const redirect = encodeURIComponent(
    window.location.href.split("?")[0] + "?integration=mailchimp"
  );
  const url = inProgress
    ? "#"
    : `https://login.mailchimp.com/oauth2/authorize?response_type=code&client_id=${MAILCHIMP_CLIENT_ID}&redirect_uri=${redirect}`;

  useEffect(() => {
    const code = getParameter("code");
    const integration = getParameter("integration");
    if (code && integration === "mailchimp") {
      setProgressFlag(true);
      async function getAccessToken() {
        showLoadingPopUp("Linking your Mailchimp account. Please wait.");
        const res = await fetch(
          `/api/mc?code=${code}&redirect_url=${redirect}`
        );
        const data = await res.json();
        if (res.status === 200) {
          if (data.lists.length === 0) {
            showAlertPopUp("You have 0 audiences/lists created in Mailchimp.");
            setProgressFlag(false);
          } else {
            await Promise.all(
              data.lists.map(async (list) => {
                const newDestination = await addDestination(
                  user,
                  DestinationType.MAILCHIMP,
                  {
                    list,
                    accessToken: data.accessToken,
                    dc: data.dc,
                  },
                  {
                    name: list.name,
                  }
                );
                addUserDestination(newDestination);
              })
            );
            setProgressFlag(false);
            closePopUp();
          }
        } else {
          onError(["Error linking to Mailchimp.", "/help/mailchimp"]);
          setProgressFlag(false);
          closePopUp();
        }
      }
      getAccessToken();
    }
  }, []);

  if (user.demo) {
    return (
      <button
        onClick={() => verifyRealUser(user, () => {})}
        className="secondary with-icon fz08"
      >
        <span className="vam">Link a Mailchimp account</span>
      </button>
    );
  }

  return (
    <a
      href={url}
      className="secondary with-icon fz08"
      data-disabled={inProgress}
    >
      {inProgress ? "⏳ " : null}
      <span className="vam">Link a Mailchimp account</span>
    </a>
  );
}
